import {
  INTERNET_CONNECTION_AVAILABLE,
  WEON_CONNECTION_AVAILABLE,
  RECONNECTION_CONFIRMATION,
  CONNECTION_PROBLEM_DIALOG,
  CONNECTION_PROBLEM_WEBRTC,
  CONNECTION_WEBRTC_STATUS,
  CONNECTION_WEBRTC_DEVICE_CONNECTION_LOST,
} from '../../mutation-types';

const mutations = {
  [WEON_CONNECTION_AVAILABLE](state, isConnectedToWeon) {
    state.weonConnectionAvailable = isConnectedToWeon;
  },
  [INTERNET_CONNECTION_AVAILABLE](state, isConnectedToInternet) {
    state.internetConnectionAvailable = isConnectedToInternet;
  },
  [RECONNECTION_CONFIRMATION](state, isConfirmed) {
    state.reconnectionConfirmation = isConfirmed;
  },
  [CONNECTION_PROBLEM_DIALOG](state, showDialog) {
    state.connectionProblemDialog = showDialog;
  },
  [CONNECTION_PROBLEM_WEBRTC](state, status) {
    state.connectionProblemWebRTC = status;
  },
  [CONNECTION_WEBRTC_STATUS](state, status) {
    state.connectionWebRTCStatus = status;
  },
  [CONNECTION_WEBRTC_DEVICE_CONNECTION_LOST](state, status) {
    state.connectionProblemWebRTCDevice = status;
  },
};

export default mutations;
